import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/custom/button'
import { cn } from '@/lib/utils'
import { RefreshCw } from 'lucide-react'

interface GeneralErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  minimal?: boolean
}

export default function GeneralError({
  className,
  minimal = false,
}: GeneralErrorProps) {
  const navigate = useNavigate()
  
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className={cn('h-svh w-full', className)}>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-3'>
        {!minimal && (
          <div className='text-6xl mb-2'>🤔</div>
        )}
        <h1 className='text-2xl font-semibold text-foreground'>
          Hmm, something's not quite right
        </h1>
        <p className='text-center text-muted-foreground max-w-md'>
          Don't worry - this happens sometimes! Give it another try or head back to where you were.
        </p>
        {!minimal && (
          <div className='mt-6 flex gap-3 flex-wrap justify-center'>
            <Button 
              variant='outline' 
              onClick={handleRefresh}
              className='flex items-center gap-2'
            >
              <RefreshCw className='h-4 w-4' />
              Try Again
            </Button>
            <Button variant='outline' onClick={() => navigate(-1)}>
              Go Back
            </Button>
            <Button onClick={() => navigate('/')}>
              Home
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}